import { useRouter } from 'next/navigation';
import { toast } from '@mokoboko/components';

import { useIsEmbed } from '@/contexts/embed';
import { openSitePage } from '@/helpers/embed-navigation';

export const useOpenSitePage = () => {
  const router = useRouter();
  const isEmbed = useIsEmbed();

  return (path: string, blockedMessage: string) => {
    if (!isEmbed) {
      router.push(path);
      return;
    }

    if (!openSitePage(path)) {
      toast.info(blockedMessage);
    }
  };
};
